// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"729fbeed","27":"cda61fe5","56":"6c6569ac","508":"e727fd90","584":"e243979f","685":"c29052b4","709":"2d907a75","741":"01ec917e","825":"c8cb42c3","873":"361cdc17","885":"88eacb13","917":"27a249ae","961":"8baf0fb2"}[chunkId] + ".chunk.css";
};